export const medication = `
title
... on Entry_Medication_Medication {
  id
  type
  url
  active_ingredients {
    title
    slug
  }
  trading_names {
    trading_name
    id
    __typename
  }
  text {
    ... on BardText {
      text
      type
      __typename
    }
    __typename
  }
  active_ingredients_and_delivery_form {
      strengths {
        title
      }
      delivery_form {
        title
      }
  }
  informationUpdate
  authHolder
  sections {
    mode
    code
    __typename
  }

  style {
    mode
    code
    __typename
  }

  content {
    mode
    code
    __typename
  }
  __typename
}
__typename
`
